import { useState, useCallback, useRef } from "react";
import axios from "axios";
import { apiV1Endpoint } from "../api/v1/endpoints";
import { message } from "antd";
import { RefreshRenwalData } from "../app/modules/BookingForm/ducks/actions";
import { useDispatch } from "react-redux";

interface UseAgGridSelectionProps {
  postUrl: string; // API endpoint for posting selected IDs
  status: string;
  leaseId: string;
}

export const useAgGridSelection = ({ postUrl, leaseId, status }: UseAgGridSelectionProps) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [deselectAll, setDeselectAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch: any = useDispatch();

  // Handle selection change
  const onSelectionChanged = useCallback((event) => {
    const reports = event.api.getSelectedNodes();
    if (reports.length > 0) {
      const reportIds = reports
        ?.filter((t) => t?.data?.status?.toLowerCase() !== "approved")
        ?.map((t) => t?.data?.reportId);

      setSelectedIds(reportIds);
    } else {
      setSelectedIds([]);
    }
  }, []);

  // Post selected IDs to backend
  const postSelectedIds = useCallback(async () => {
    if (!selectedIds.length) return;

    setLoading(true);
    try {
      const response = await axios.post(`${apiV1Endpoint}${postUrl}`, { leaseId, reportIds: selectedIds, status });
      setSelectedIds([]);
      message.success("Select Reports Approved Successfully");
      dispatch(RefreshRenwalData());
      return response.data;
    } catch (error: any) {
      console.error("Error posting selected IDs:", error);
      throw error;
    } finally {
      setDeselectAll(false);
      setLoading(false);
    }
  }, [selectedIds, postUrl]);

  return {
    selectedIds,
    selectionLoading: loading,
    onSelectionChanged,
    postSelectedIds,
    deselectAll,
  };
};
